// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xJbw-","content":"styles_content__t21FK","selectAll":"styles_selectAll__35eXE"};